module.exports = __webpack_public_path__ + "static/media/2.5304be19.png";